const { cELM, Wrap4ArrowMulti } = require("../../utils");
const Chat = require("../../chat");

const DATES = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

class DOBInput {
  constructor(data) {
    this._data = data;
    this.element = cELM("div", "option-block");
    this.__elements = null;
    this.createElement();
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  createElement() {
    const _self = this;
    const inputContainer = cELM("div", "inputs-wrapper");
    const dayEl = cELM("input", "date-input");
    const dayWp = Wrap4ArrowMulti(dayEl);
    const monthEl = cELM("input", "date-input");
    const monthWp = Wrap4ArrowMulti(monthEl, true);
    const yearEl = cELM("input", "date-input");
    const yearWp = Wrap4ArrowMulti(yearEl);

    dayEl.type = "number";
    monthEl.type = "number";
    yearEl.type = "number";
    monthEl.autofocus = true;
    console.log(this._data)
    dayEl.placeholder = getLngTxt("placeholder.day") || "Day";
    monthEl.placeholder = getLngTxt("placeholder.month")|| "Month";
    yearEl.placeholder = getLngTxt("placeholder.year") || "Year";

    dayEl.pattern = "[0-9]*";
    monthEl.pattern = "[0-9]*";
    yearEl.pattern = "[0-9]*";

    const buttonEl = cELM("div", "continue-button", getLngTxt("button.continue"));

    // validator
    function validate(silent = false) {
      let isValid = true;

      if (!silent) {
        monthEl.classList.remove("invalid");
        dayEl.classList.remove("invalid");
        yearEl.classList.remove("invalid");
      }

      if (yearEl.value.length !== 2 && yearEl.value.length !== 4) {
        isValid = false;
        if (!silent) {
          yearEl.classList.add("invalid");
          yearEl.focus();
        }
      }
      //AR: not sure if we should change this behavior
      // else if (yearEl.value.length == 2 && (Number(yearEl.value) == 20 || Number(yearEl.value) == 19)){
      //   isValid = false;
      //   if (!silent) {
      //     yearEl.classList.add("invalid");
      //     yearEl.focus();
      //   }        
      // }

      if (Number(dayEl.value) <= 0 || Number(dayEl.value) > 31) {
        isValid = false;
        if (!silent) {
          dayEl.classList.add("invalid");
          dayEl.focus();
        }
      }

      if (Number(monthEl.value) <= 0 || Number(monthEl.value) > 12) {
        isValid = false;
        if (!silent) {
          monthEl.classList.add("invalid");
          monthEl.focus();
        }
      }

      if (isValid && dayEl && monthEl) {
        const day = Number(dayEl.value);
        const month = Number(monthEl.value);
        if (day > DATES[month - 1]) {
          isValid = false;
          if (!silent) {
            dayEl.classList.add("invalid");
            dayEl.focus();
          }
        }
      }

      return isValid;
    }

    // event listeners
    buttonEl.onclick = function(evt) {
      if (!validate()) return;

      let year = Number(yearEl.value);
      if (year <= 25) year = 2000 + year;
      else if (year > 25 && year < 1000) year = 1900 + year;

      const op =
        monthEl.value.padStart(2, "0") + "/" + dayEl.value.padStart(2, "0") + "/" + year.toString();

      Chat.default.send({
          text: op,
          id: _self._data.id,
          answerKey: _self._data.answerKey
        },
        null,
        _self.element
      );
    };

    // const onFocusChange = function(evt) {
    //   monthWp.classList.remove("arrow-active");
    //   dayWp.classList.remove("arrow-active");
    //   yearWp.classList.remove("arrow-active");
    //
    //   if (evt && evt.target) {
    //     evt.target.parentNode.classList.add("arrow-active");
    //   }
    // };

    const onKeyUp = (el, nextEl, limit, type) =>
      function(evt) {
        var kc = evt.which || evt.keyCode;
        console.log(kc)
        if (!kc || kc == 229) {
          let ss = evt.target.selectionStart - 1;
          let ssv = ss || 0;
          let char = evt.target.value.substr(ssv, 1);
          kc = char.charCodeAt(0);
        }

        if (el.value.length < 2 && type === "month") {
          const goToNext = (kc > 49 && kc < 58) || kc > 97;

          if (goToNext) {
            // bigger than or equal to 2
            nextEl.focus();
          }
        } else if (el.value.length < 2 && type === "day") {

          const goToNext = (kc > 51 && kc < 58) || kc > 99;

          if (goToNext) {
            // bigger than or equal to 4
            nextEl.focus();
          }
        }

        if (el.value.length > limit) {
          el.value = el.value.slice(0, limit);
        }

        if (el.value.length >= limit) {
          if (nextEl) {
            nextEl.focus();
          }

          if (type === "year") {
            el.blur();
            buttonEl.click();
          }
        }

        if (
          type === "year" &&
          el.value.length === 2 &&
          Number(el.value) !== 19 &&
          Number(el.value) !== 20
        ) {
          el.blur();
          buttonEl.click();
        }

        if (validate(true)) {
          monthWp.classList.remove("arrow-active");
          dayWp.classList.remove("arrow-active");
          yearWp.classList.remove("arrow-active");
          buttonEl.classList.add("continue-button-active");
          buttonEl.classList.add("arrow-active");

          if (evt.key === "Enter") {
            el.blur();
            buttonEl.click();
          }
        } else {
          buttonEl.classList.remove("continue-button-active");
          buttonEl.classList.remove("arrow-active");
        }
      };

    const onKeyDown = function(evt) {
      // disable inputing "e"
      return evt.keyCode !== 69;
    };

    // bind events
    // monthEl.onfocus = onFocusChange;
    // dayEl.onfocus = onFocusChange;
    // yearEl.onfocus = onFocusChange;

    monthEl.onkeyup = onKeyUp(monthEl, dayEl, 2, "month");
    dayEl.onkeyup = onKeyUp(dayEl, yearEl, 2, "day");
    yearEl.onkeyup = onKeyUp(yearEl, buttonEl, 4, "year");

    dayEl.onkeydown = onKeyDown;
    monthEl.onkeydown = onKeyDown;
    yearEl.onkeydown = onKeyDown;

    // add elements to container
    // monthWp.addELM(monthEl);
    inputContainer.addELM(monthWp);
    // dayWp.addELM(dayEl);
    inputContainer.addELM(dayWp);
    // yearWp.addELM(yearEl);
    inputContainer.addELM(yearWp);

    this.element.addELM(inputContainer);
    this.element.addELM(buttonEl);

    // store each element for references
    this.__elements = { dayEl, monthEl, yearEl };
    return this.element;
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.monthEl.value = "";
    this.__elements.dayEl.value = "";
    this.__elements.yearEl.value = "";
    this.__elements.monthEl.focus();
  }

  focus() {
    if (!this.__elements) return;
    //this.__elements.monthEl.focus();
  }
}

module.exports = DOBInput;
